import React from 'react';
import CustomValueFilter from './Filters/CustomValue';
import DateRangeFilter from './Filters/DateRange';
import NumericRangeFilter from './Filters/NumericRange';
import ValueFilter from './Filters/Value';
import './style.scss';
var SearchSelectedFilters = function SearchSelectedFilters(_ref) {
  var _results$summary;
  var data = _ref.data,
    loading = _ref.loading;
  if (!data) {
    return null;
  }
  var results = data.results;

  // All filter components are copies of Searchkit's own filters, recreated within our library.
  // Only the CustomValueFilter is a completely custom filter, written by us. Hence the name.
  var filterComponentMap = {
    ListFacet: CustomValueFilter,
    RangeSliderFacet: NumericRangeFilter,
    DateRangeFacet: DateRangeFilter,
    ComboBoxFacet: ValueFilter,
    HierarchicalMenuFacet: ValueFilter,
    SelectFacet: CustomValueFilter,
    ChipFacet: CustomValueFilter,
    HierarchicalFilterFacet: CustomValueFilter
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "SearchSelectedFilters"
  }, results === null || results === void 0 ? void 0 : (_results$summary = results.summary) === null || _results$summary === void 0 ? void 0 : _results$summary.appliedFilters.map(function (filter) {
    var FilterComponent = filterComponentMap[filter.display] || ValueFilter;
    if (!filterComponentMap[filter.display]) {
      throw new Error("could not display selected filters for ".concat(filter.identifier, " facet. Use customFilterComponents prop to pass a component to handle this filter for ").concat(filter.display, " display"));
    }
    return /*#__PURE__*/React.createElement(FilterComponent, {
      filter: filter,
      loading: loading,
      key: filter.id
    });
  }));
};
export default SearchSelectedFilters;